export function getSourceLayers(sourceInfo) {
    if (!sourceInfo)
        return [];
    const { tileJSON, metadata } = sourceInfo;
    if (tileJSON) {
        return tileJSON.vector_layers.map(({ id, description, minzoom: minZoon, maxzoom: maxZoom }) => ({
            id,
            description,
            minZoon,
            maxZoom,
        }));
    }
    if (metadata && "vectorLayers" in metadata) {
        return metadata.vectorLayers.map(({ id, description, minZoom, maxZoom }) => {
            return {
                id,
                description,
                minZoom,
                maxZoom,
            };
        });
    }
    return [];
}
/**
 * Push item to layer array
 * Use as hack to add layer to layer array avoid infinite type recursion
 */
export function pushToLayers(arr, item) {
    arr.push(item);
}
/**
 * Filter layers by search string
 */
export function filterLayers(layers, search = "") {
    const searchString = search.toLowerCase().trim();
    if (!searchString)
        return layers;
    return layers.filter(layer => layer.id.toLowerCase().includes(search));
}
